import { Pipe, PipeTransform } from '@angular/core';
import { NullableString } from '@models/app.models';
import { asString } from '@utils/data-utils';

@Pipe({
  name: 'interpolate',
  standalone: true,
})
export class InterpolatePipe implements PipeTransform {
  transform(
    text: NullableString,
    values: (NullableString | number | Date)[],
    culture?: NullableString,
    format?: string,
  ): string {
    if (values.length <= 0) {
      return text ?? '';
    }
    return values.reduce<string>((txt, value, idx) => {
      return txt.replace(
        new RegExp(`{[${idx}]}`, 'g'),
        asString(value, culture, format),
      );
    }, text ?? '');
  }
}
